// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3MTBN","approved":"Status_approved__U7DG9","rejected":"Status_rejected__1fSTJ","expired":"Status_expired__3l4AG","label":"Status_label__18zkw"};